import React from "react";
import { TransferPaymentsContext } from "./TransferPaymentContext";
export const useTransferPaymentsContext = () => {
    const context = React.useContext(TransferPaymentsContext);
    if (context == null) {
        throw new Error("This component must be used within a <TransferPayments> component.");
    }
    return context;
};
